// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3Wc5k","header":"MergedInvoice_header__1fp8V"};